'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _thenby = require('thenby');

var _thenby2 = _interopRequireDefault(_thenby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                     * Sort table using particular column's sorting fn
                                                                                                                                                                                                     */


var sortData = function sortData(data, columns, idx, defaultIdx) {
  return [].concat(_toConsumableArray(data)).sort((0, _thenby2.default)(columns[idx].sortFn).thenBy(columns[defaultIdx].sortFn));
};

exports.default = sortData;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/sortData.js
// module id = 1020
// module chunks = 0